import { useEffect } from 'react'
import dashedLine from '../images/dashed-curved-map-line.svg'
import { select } from 'd3'

type Screen3Props = {
  anchorRef: React.RefObject<SVGSVGElement>
}

const Screen3 = ({ anchorRef }: Screen3Props) => {
  const { x, y, width } = anchorRef.current?.getBoundingClientRect()!
  useEffect(() => {
    const ref = anchorRef.current
    select(ref).style('z-index', 1000).style('pointer-events', 'none')
    return () => {
      select(ref).style('z-index', 'initial').style('pointer-events', 'initial')
    }
  }, [anchorRef])
  return (
    <div className="flex h-full bg-[#222222] opacity-[.78] w-screen relative">
      <div
        className="flex flex-col items-center w-[294px] gap-1 absolute"
        style={{
          left: `${x + width / 2}px`,
          top: `${y - 200}px`,
        }}
      >
        <p className="text-orange font-decimal text-[20px]">
          Zoom and pan around the map to explore, and click on any data point on
          the map to learn more about the organization.
        </p>
        <img src={dashedLine} alt="dashed line" className="self-end" />
      </div>
    </div>
  )
}
export default Screen3
